export default __webpack_public_path__ + "static/media/microtik.ed903bee.png";